module.exports = __webpack_public_path__ + "assets/media/s39.ac2ee019.mp3";